import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export function Card({
  className,
  ...rest
}: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div
      className={cn(
        'rounded-xl border border-surface-divider bg-surface-raised p-5',
        className,
      )}
      {...rest}
    />
  );
}

export function CardLabel({
  className,
  ...rest
}: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div
      className={cn(
        'text-xs font-bold uppercase tracking-wide text-fg-muted',
        className,
      )}
      {...rest}
    />
  );
}
